export const BASE_API_URL: string | undefined = process.env.REACT_APP_API_URL;

export type Endpoint = {
  url: string;
};
